import { render, staticRenderFns } from "./LightboxBase.vue?vue&type=template&id=3ac0af1c&scoped=true"
import script from "./LightboxBase.vue?vue&type=script&lang=js"
export * from "./LightboxBase.vue?vue&type=script&lang=js"
import style0 from "./LightboxBase.vue?vue&type=style&index=0&id=3ac0af1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac0af1c",
  null
  
)

export default component.exports